import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as RSTooltip } from 'reactstrap';

/**
 * Makes a controlled tooltip
 */
class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tooltipOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    const { text, id, dynVars = {}, ...otherProps } = this.props;

    return (
      <RSTooltip
        isOpen={this.state.tooltipOpen}
        target={id}
        toggle={this.toggle}
        placement={'top'}
        {...otherProps}
      >
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </RSTooltip>
    );
  }
}

Tooltip.propTypes = {
  // XXX See reactstrap doc for dull documentation https://reactstrap.github.io/components/tooltips/
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  placement: PropTypes.string,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/Tooltip.js